<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view v-if="isRouterAlive"></router-view>>
    </transition>
  </div>
</template>

<script>
// import { requireConfig } from './util/wxShare'
// import Utils from '../src/util/util'

export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      transitionName: 'slide-right',
      isRouterAlive: true
    }
  },
  mounted() {
    // requireConfig()
  },
  watch: {
    $route() {
      const isBack = this.$router.isBack
      if (isBack) {
        this.transitionName = 'slide-right'
      } else {
        this.transitionName = 'slide-left'
      }
      this.$router.isBack = false
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  display: flex;
  justify-content: center;
  align-items: center;
}
// .slide-left-enter, .slide-right-leave-to {
//   opacity: 1;
//  transform: translate3d(100% 0 0);
// }

// .slide-left-leave-to, .slide-right-enter {
//   opacity: 1;
//   transform: translate3d(-100% 0 0);
// }

// .slide-left-enter-active, .slide-left-leave-active, .slide-right-enter-active, .slide-right-leave-active {
//   // will-change: transform;
//   transition: all .3s ease;
// }

// 竖屏
@media screen and (orientation: portrait) {
  #app {
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    -webkit-transform-origin: 50vw 50vw;
    -moz-transform-origin: 50vw 50vw;
    -ms-transform-origin: 50vw 50vw;
    transform-origin: 50vw 50vw;
    width: 100vh !important;
    height: 100vw !important;
  }
}

@media screen and (orientation: landscape) {
  #app {
    -webkit-transform: rotate(0);
    -moz-transform: rotate(0);
    -ms-transform: rotate(0);
    transform: rotate(0);
  }
}
</style>
